if (!customElements.get('bt-product-view')) {
  class BtProductView extends HTMLElement {
    connectedCallback() {
      if (this.recorded) return;
      this.recorded = true;

      const productId = this.dataset.productId;
      if (!/^\d+$/.test(productId || '')) return;

      this.recordView(productId);
    }

    async recordView(productId) {
      try {
        const response = await fetch('/apps/bt-signals/v1/views', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ product_id: productId, guest_id: window.btSignalsGetGuestId() }),
        });
        if (!response.ok) return;
      } catch (_error) {
        return;
      }
    }
  }

  customElements.define('bt-product-view', BtProductView);
}